import { render, staticRenderFns } from "./sourcing-detail.vue?vue&type=template&id=784d8a14&scoped=true"
import script from "./sourcing-detail.vue?vue&type=script&lang=js"
export * from "./sourcing-detail.vue?vue&type=script&lang=js"
import style0 from "./sourcing-detail.vue?vue&type=style&index=0&id=784d8a14&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d8a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784d8a14')) {
      api.createRecord('784d8a14', component.options)
    } else {
      api.reload('784d8a14', component.options)
    }
    module.hot.accept("./sourcing-detail.vue?vue&type=template&id=784d8a14&scoped=true", function () {
      api.rerender('784d8a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quotation-apply/sourcing-detail.vue"
export default component.exports